import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

// Resolvers map a shorthand tab to its deep-link path using Redux state.
// Each resolver returns a string path, or null if required state isn't ready yet.
var resolvers = {
  view: function (state) {
    var account = state.accounts && state.accounts.currentAccount;
    if (!account) return null;
    var view = state.slateViews && state.slateViews.currentSlateView;
    var viewUuid = view && view.uuid ? view.uuid : '';
    return '/accounts/' + account.uuid + '/views/' + viewUuid;
  },
  inspect: function (state) {
    var account = state.accounts && state.accounts.currentAccount;
    if (!account) return null;
    return '/accounts/' + account.uuid + '/inspect';
  },
};

var TabRedirect = function (props) {
  if (!props.to) return null;
  return <Redirect to={props.to} />;
};

var makeRedirect = function (tab) {
  var mapState = function (state) {
    return { to: resolvers[tab](state) };
  };
  return connect(mapState)(TabRedirect);
};

export var ViewTabRedirect = makeRedirect('view');
export var InspectTabRedirect = makeRedirect('inspect');
